export default __webpack_public_path__ + "static/media/RecommendationWithoutEdit.8775deb0.png";